class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.detailsContainer.addEventListener('toggle', () => {
      if (this.isOpen() || !this.focusTrapActive) return;
      const active = document.activeElement;
      const restoreFocus = !active || active === document.body || !active.isConnected || this.contains(active);
      this.close(restoreFocus);
    });
    // Search apps can insert or replace buttons after the theme initializes.
    this.addEventListener('click', (event) => {
      if (event.target.closest('.modal__close-button')?.closest('details-modal') === this) this.close();
    });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    // An app can remove its Clear control before this click reaches the body.
    // The propagation path still identifies the click as originating inside search.
    const inside = event.composedPath ? event.composedPath().includes(this) : this.contains(event.target);
    if (!inside || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.focusTrapActive = true;
    DetailsModal.activeModal = this;

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    // A closed search must not remove the focus trap or scroll lock of another dialog.
    if (!this.isOpen() && !this.focusTrapActive) return;
    this.focusTrapActive = false;
    const ownsFocusTrap = !DetailsModal.activeModal || DetailsModal.activeModal === this;
    if (ownsFocusTrap) {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
      DetailsModal.activeModal = null;
      document.body.classList.remove('overflow-hidden');
    }
    this.detailsContainer.removeAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }

  disconnectedCallback() {
    this.close(false);
    document.body.removeEventListener('click', this.onBodyClickEvent);
  }
}

customElements.define('details-modal', DetailsModal);
